export const ADD_TEMPLATE_SUCCESS = "Template created successfully";
export const UPDATE_TEMPLATE_SUCCESS = "Template updated successfully";
export const SYNC_TEMPLATE_SUCCESS = "Template resynced successfully";
export const SYNC_TEMPLATE_FAILED = "Template resynced failed...please try again..!!" 
export const DELETE_TEMPLATE_SUCCESS = "Template deleted successfully";
export const PAUSE_UPDATE_SUCCESS = "Template {{status}} successfully";
export const PAUSE_UPDATE_FAILED = "Template pause update failed";
export const TEMPLATE_UPDATE_NOTIFICATION_SUCCESS = "Template notification {{status}} successfully";
export const TEMPLATE_UPDATE_NOTIFICATION_FAILED = "Template notification update failed !!!";
export const ADD_COMPANY_SUCCESS = "Company created successfully";
export const UPDATE_COMPANY_SUCCESS = "Company updated successfully";
export const DELETE_COMPANY_SUCCESS = "Company deleted successfully";
export const SHIFT_SETTING_CONFIG_SUCCESS =
  "Shift config updated successfully";
export const SHIFT_SETTING_CONFIG_DELETE_SUCCESS =
  "Shift config deleted successfully";

export const ADD_PART_SUCCESS = "Part created successfully";
export const UPDATE_PART_SUCCESS = "Part updated successfully";
export const DELETE_PART_SUCCESS = "Part deleted successfully";


export const ADD_STAFF_SUCCESS = "{{staff}} created successfully";
export const UPDATE_STAFF_SUCCESS = "{{staff}} updated successfully";
export const DELETE_STAFF_SUCCESS = "{{staff}} deleted successfully";
export const UPDATE_STAFF_FAILED = "{{staff}} update failed";
export const ADD_STAFF_FAILED = "{{staff}} add failed";

export const FAILED_FETCH_COMPANINES ="Failed to fetch companies.";
export const SELECT_TEMPLATE= "Please select a template to view breakdowns.";
export const FAILED_FETCH_BREAKDOWN = "Failed to fetch breakdowns.";
export const BREAKDOWN_UPDATE_SUCCESS="Breakdown for {{slot}} {{state}} successfully!";
export const BREAKDOWN_UPDATE_FAILED="Failed to {{state}} record for {{slot}}.";
export const FETCH_BREAKDOWN_REASON_ERROR ="Failed to fetch breakdown reasons."

// Shift Setting Clipboard 

export const SHIFT_CONFIG_COPY_SUCCESS="Shift config copied to clipboard!"
export const SHIFT_CONFIG_COPY_FAILED="Failed to copy Shift Config:"

export const SHIFT_CONFIG_PASTE_FAILED="Failed to paste Shift Config:"

export const ADD_PRODUCTION_COMPONENT_SUCCESS = 'Production Component added successfully';
export const UPDATE_PRODUCTION_COMPONENT_SUCCESS = 'Production Component updated successfully';
export const DELETED_PRODUCTION_COMPONENT_SUCCESS = 'Production Component deleted successfully';

export const NOTIFICATION_UPDATE_SUCCESS = 'Notification Settings updated successfully'
export const NOTIFICATION_UPDATE_FAILED = 'Notification Settings Failed'

export const STAFF_IMPORT_SUCCESS = "Staff data imported successfully"
export const STAFF_IMPORT_FAILED = "Staff data import failed"

export const STAFF_ATTENDENCE_IMPORT_SUCCESS = "Staff data imported successfully"
export const STAFF_ATTENDENCE_IMPORT_FAILED = "Staff data import failed"

export const ADD_USER_SUCCESS = "User created successfully";
export const UPDATE_USER_SUCCESS = "User updated successfully";
export const DELETE_USER_SUCCESS = "User deleted successfully";
export const USER_STATUS_UPDATE_SUCCESS = "User status updated successfully";

export const CHANGE_PASSWORD_SUCCESS = "Password changed successfully";
export const FORGOT_PASSWORD_SUCCESS = "Password reset link sent to your email";